import { render, staticRenderFns } from "./KeyTwo.vue?vue&type=template&id=b0f4526c&scoped=true&"
import script from "./KeyTwo.vue?vue&type=script&lang=js&"
export * from "./KeyTwo.vue?vue&type=script&lang=js&"
import style0 from "./KeyTwo.vue?vue&type=style&index=0&id=b0f4526c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f4526c",
  null
  
)

export default component.exports